import { CustomerPage } from "@/components/customer-detail/customer-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/customer/$kundennummer")({
  component: CustomerPage,
});
